import "./foundDrift.scss";
import {Checkbox} from "antd";
import AppToggle from "../../../../shared/appToggle/appToggle";
import CodeDiff from "../../../../shared/codeDiff/codeDiff";
import {ERR_FOUND_SOME_DRIFTS, ERR_FOUND_SOME_DRIFTS_NO_CHANGE, ERR_NO_CHANGE} from "../../../../consts/errorCodes";
import _ from "lodash";
import React from "react";
import CopyBox from "../../../../shared/copyBox/copyBox";


const FoundDrift = ({obj, setChecked, setShowDiff}) => {
    const checkboxText = <div className="col"><span>{obj?.repo}, {obj?.resourceFilePath}</span></div>
    return (
        <span className="FoundDrift col">
            <span>
                {!_.isUndefined(obj?.error) &&
                    <span>
                        {obj?.responseText}
                    </span>
                }
                {!_.isUndefined(obj?.error) && (obj?.error === ERR_NO_CHANGE || obj?.error === ERR_FOUND_SOME_DRIFTS_NO_CHANGE) &&
                    <span className="FoundDrift__find-diff-command row" style={{ marginTop: '5px' }}>
                        <CopyBox
                            text={`terraform refresh -target "${obj?.objectInfo?.objectModule && `${obj?.objectInfo?.objectModule}.`}${obj?.objectInfo?.objectType}.${obj?.objectInfo?.objectName}"`}
                            darkMode
                        />
                    </span>
                }
            </span>
            {(_.isUndefined(obj?.error) || obj?.error === ERR_FOUND_SOME_DRIFTS) &&
                (
                    <span>
                        <span className="FoundDrift__find row between bold">
                            {!obj?.isSingle ? <Checkbox key={obj?.id} checked={obj?.isChecked} onChange={(e) => setChecked(e, obj?.id)}>
                            <span style={{ color: 'white' }}>{checkboxText}</span>
                            </Checkbox> : checkboxText}
                            <span className="row FoundDrift__find-toggle">
                                <AppToggle
                                    checked={obj?.showDiff}
                                    toggleChecked={() => setShowDiff(obj?.id)}
                                    loading={false}
                                />
                            </span>
                        </span>
                        <span className="FoundDrift__find row between">
                            {obj?.showDiff && (
                                <span className="col FoundDrift__find-diff">
                                  <span className="FoundDrift__find-diff-code">
                                        <CodeDiff lang="hcl" obj={obj}/>
                                    </span>
                                    <span className="FoundDrift__find-diff-commandDescription row bold">
                                        To fix asset drifts in the cloud and not in the IaC repo, run the following command:
                                    </span>
                                    <span className="FoundDrift__find-diff-command row">
                                         <CopyBox
                                             text={`terraform apply -target "${obj?.objectInfo?.objectModule && `${obj?.objectInfo?.objectModule}.`}${obj?.objectInfo?.objectType}.${obj?.objectInfo?.objectName}"`}
                                             darkMode
                                        />
                                    </span>
                                </span>
                            )}
                        </span>
                    </span>
                )
            }
        </span>
    );
};

export default FoundDrift;
